<!-- 试卷预览页面 -->
<template>
  <div class="exam-beginning-right">
    <div
      v-for="(item, index) in answerList"
      :key="item.examsQuestionId"
      class="answer-box"
    >
      <div v-if="item.examsQuestionTypeId == 1">
        <div class="answer-head">
          <span class="answer-number">{{ index + 1 }}</span>
          <span class="answer-style"
            >（单选题，{{ scoreList.type1 }}分）</span
          >
        </div>
        <div v-html="item.content"></div>
        <p v-for="(value, key, index) in item.answerOptions" :key="index">
          {{ key }}.{{ value }}
        </p>
        <el-radio-group
          v-model="answer[index]"
          style="margin-left: 10px"
        >
          <el-radio
            v-for="(value, key, index) in item.answerOptions" :key="index"
            :label="key"
            >{{ key }}</el-radio
          >
        </el-radio-group>
      </div>
      <div v-if="item.examsQuestionTypeId == 2">
        <div class="answer-head">
          <span class="answer-number">{{ index + 1 }}</span>
          <span class="answer-style"
            >（多选题，{{ scoreList.type2 }}分）</span
          >
        </div>
        <div v-html="item.content"></div>
        <p v-for="(value, key, index) in item.answerOptions" :key="index">
          {{ key }}.{{ value }}
        </p>
        <el-checkbox-group
          v-model="answer[index]"
          size=""
          style="margin-left: 10px"
        >
          <el-checkbox
            v-for="(value, key, index) in item.answerOptions" :key="index"
            :label="key"
            >{{ key }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div v-if="item.examsQuestionTypeId == 3">
        <div class="answer-head">
          <span class="answer-number">{{ index + 1 }}</span>
          <span class="answer-style"
            >（判断题，{{ scoreList.type3 }}分）</span
          >
        </div>
        <div v-html="item.content"></div>
        <el-radio-group
          v-model="answer[index]"
          style="margin-left: 10px"
        >
          <el-radio
            v-for="(value, key, index) in item.answerOptions" :key="index"
            :label="key"
            >{{ value }}</el-radio
          >
        </el-radio-group>
      </div>
      <div v-if="item.examsQuestionTypeId == 4">
        <div class="answer-head">
          <span class="answer-number">{{ index + 1 }}</span>
          <span class="answer-style"
            >（填空题，{{ scoreList.type4 }}分）</span
          >
        </div>
        <div v-html="item.content"></div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入答案"
          v-model="answer[index]"
        >
        </el-input>
      </div>
      <div v-if="item.examsQuestionTypeId == 5">
        <div class="answer-head">
          <span class="answer-number">{{ index + 1 }}</span>
          <span class="answer-style"
            >（论述题，{{ scoreList.type5 }}分）</span
          >
        </div>
        <div v-html="item.content"></div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入答案"
          v-model="answer[index]"
        ></el-input
>
        <!-- </el-input> -->
      </div>
    </div>
  </div>
</template>

<script>
// import * as api from '@/api/exam/exam'
// import { getMessage3, sendMessage3 } from '@/api/invigilate/invigilateList'
// import { Loading } from 'element-ui'
// import { unserialize, serialize } from '@/utils/common'

export default {
  name: 'ExamPaperPreview',
  data() {
    return {
      uid: '',        // 考试id 
      answerList: [], //题目列表
      answer: [],     //作答数据
      scoreList: [],  // 分数列表

    }
  },
  computed: {
    // url() {
    //   let url = window.location.protocol + '//' + window.location.host
    //   if (window.location.host == 'localhost:5001') {
    //     url = 'http://gz.hnjk.net'
    //   }
    //   return url
    // },
  },
  methods: {


  },
}
</script>

<style lang="scss" scoped>
.mainDiv {
  margin: 0;
  padding: 0;
  min-width: 1366px;
}
.head {
  background-color: #116fc6;
  color: white;
  padding: 5px;
  font-size: 24px;
  font-weight: 600;
}
.exam {
  height: 600px;
}
.exam > div {
  // display: inline-block;
  float: left;
}
.exam-left {
  width: 80%;
  height: 100%;
}
.exam-before {
  height: 100%;
  position: relative;
  background-color: #f2f2f2;
}
.exam-before-text {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 30px;
  font-weight: 600;
}
.exam-before-text > p {
  white-space: nowrap;
}
.exam-right {
  width: 20%;
  background-color: #37526d;
  padding: 20px;
  color: white;
}
.exam-img {
  width: 100%;
  margin-top: 10px;
}
.exam-img-text {
  text-align: center;
  background-color: #0083fd;
  padding: 10px 0;
}
.exam-beginning {
  float: left;
  width: 100%;
  height: 100%;
}
.exam-beginning > div {
  float: left;
}
.exam-beginning-left {
  width: 20%;
}
.countdown {
  padding: 10px;
  background-color: #e7f3ff;
}
.countdown-circle {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 1px solid #84a2c2;
  padding: 10px;
  color: #84a2c2;
  margin: auto;
  padding-top: 60px;
  text-align: center;
}
.countdown-circle > p {
  white-space: nowrap;
}
.countdown-time {
  font-size: 24px;
  font-weight: 700;
}
.answer-list-title {
  text-align: center;
  padding: 10px 0;
}
.answer-list-ul {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.answer-list-li {
  border: 1px solid #cacaca;
  padding: 5px 0;
  width: 20%;
}
.answer-list-circle {
  border: 1px solid #cacaca;
  border-radius: 50%;
  // padding: 5px 0px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin: auto;
  text-align: center;
  color: #cacaca;
}
.answer-list-circle-select {
  border: 1px solid #409eff;
  background-color: #409eff;
  border-radius: 50%;
  // padding: 5px 0px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin: auto;
  text-align: center;
  color: white;
}
.exam-beginning-right {
  height: 100%;
  width: 80%;
  padding: 20px;
  overflow-y: scroll;
}
.answer-head {
  color: #00bed4;
}
.answer-number {
  color: white;
  background-color: #00bed4;
  width: 35px;
  height: 35px;
  text-align: center;
  padding-top: 7px;
  border-radius: 50%;
  display: inline-block;
}
.answer-style {
  color: #00bed4;
}
.answer-box {
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0;
}
.answer-box > p {
  margin: 10px;
  color: #909192;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}






.clear:after {
  display: block;
  clear: both;
  content: '';
  height: 0;
  visibility: hidden;
}







</style>
